import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { doUpdatePassword, doResetPassword } from '../../store/find.slice';
import { RootState } from '../../store/rootReducer';

import { useSnackbar } from 'notistack';

import Spinner from '../../components/Spinner';
import Button from '../../components/Button';
import { errorVariant, infoVariant, successVariant, warningVariant } from '../../lib/barVariant';


interface IProps {
    onClose: any
}

const UpdatePassword: FC<IProps> = ({ onClose }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { data, isLoading } = useSelector((state: RootState) => state.verify);
  const { webId, memberName, token } = data;
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

    // 비밀번호 체크
  const checkValidPassword = (password: string) => {
    const passwordPattern = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[^\w\s]).{8,20}$/;
    return !passwordPattern.test(password);
  }

  const onUpdatePassword = async () => {
    if (!password) {
      return enqueueSnackbar(t('auth.findPassword.message3'), infoVariant);
    }
    if (password !== confirmPassword) {
      return enqueueSnackbar(t('auth.findPassword.message4'), infoVariant);
    }
    
    if(checkValidPassword(password)) {
        return enqueueSnackbar(t('auth.findPassword.message6'), infoVariant);
    }
    const res = await dispatch(doUpdatePassword({
        webId,
        memberName,
        token,
        memberType: 'E'
      }));
      
    switch (res?.status) {
      case 200:
        enqueueSnackbar(t('auth.findPassword.message5'), successVariant);
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }

    const res2 = await dispatch(doResetPassword({
        memberCode: res.data.data.memberCode,
        webPass: password,
        token: res.data.data.token
    }));
    
    onClose();
  }

  return (
    <>
      {isLoading ? <Spinner /> : null}
      <div className="bx-row">
        <div className="bx-input">
          <input type="password"
                 placeholder={t('auth.findPassword.placeholder2')}
                 value={password}
                 onChange={e => setPassword(e.target.value)}
          />
        </div>
      </div>
      <div className="bx-row">
        <div className="bx-input">
          <input type="password"
                 className="form-control"
                 placeholder={t('auth.findPassword.placeholder3')}
                 value={confirmPassword}
                 onChange={e => setConfirmPassword(e.target.value)}
          />
        </div>
      </div>
      <div
        className="bx-row row-info"
      >
        · {t('campus.staff.text10')}
      </div>
      <div className="btn-area">
        <button type="button"
                className="btn-basic pink"
                onClick={onUpdatePassword}
        >
          {t('auth.findPassword.title')}
        </button>
      </div>
    </>
  )
}

export default UpdatePassword;
